import { createContext } from 'react'
export const ComingUpContext = createContext('dashboard')
